import { AfterViewInit, Component, Input } from '@angular/core';
import { NgFor } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { NbCardModule, NbPopoverModule, NbInputModule, NbDatepickerModule, NbSelectModule, NbOptionModule, NbIconModule, NbButtonModule, NbSpinnerModule } from '@nebular/theme';
import { NgLetModule } from 'ng-let';
import { entryProp } from '../../../interfaces/apiCalls';
import { BaseCreatingEditing } from '../../../shared-classes/BaseCreatingEditing';
import { StatusIconDirective } from '../../../directives/status-icon.directive';
@Component({
  selector: 'app-options-input',
  standalone: true,
  imports: [NbCardModule, FormsModule, ReactiveFormsModule, NgFor, NbPopoverModule, NbInputModule, NbDatepickerModule, NbSelectModule, NbOptionModule, NbIconModule, NbButtonModule, MatRippleModule, NbSpinnerModule, NbDateFnsDateModule, NgLetModule, StatusIconDirective],
  templateUrl: './options-input.component.html',
  styleUrls: ['./options-input.component.scss']
})
export class OptionsInputComponent implements AfterViewInit{

  
  @Input('parentRef') parent: BaseCreatingEditing;
  @Input() field : entryProp ; // this is the form field ref, it is passed here from a template variable of the parent component and is not defined on the parent component itself !

  ngAfterViewInit() {
    console.devlog('OptionsInputComponent field:', this.field)
  }
}
